// extracted by mini-css-extract-plugin
export var orderDetails = "_qv-2";
export var orderImage = "_qv-1";
export var orderMeta = "_qv-3";
export var orderSummary = "_qv-0";
export var rightArrow = "_qv-4";